(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name UserController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('UserController', UserController);

    UserController.$inject = ['$scope','UserService','$window'];


    function UserController($scope,UserService,$window)
    {
        console.log("UserController");
      var vm = this;
      vm.username = "";
      vm.recuperarclave = false;
      vm.msgerror = false;
      vm.msgerrorlogin = false;
      vm.msgemail = false;
      vm.errors = false;
      vm.reseteado = false;
      vm.loading = false;

        vm.changepassword = function(form){
            vm.msgerror = false;
            UserService.Changepassword(vm).then(function(data){
                vm.finalpass = data.finalpass;
                vm.msgerrorcontra = data.msgerrorcontra;
                vm.msgerror = data.msgerror;
                vm.msgerrorlogin = data.msgerrorlogin;
            });
        };

        vm.recovery = function(form){
            vm.msgerror = false;
            vm.msgemail = false;
            vm.loading = true;
            UserService.Recuperarpassword(vm).then(function(data){
                vm.msgerror = data.msgerror;
                vm.msgemail = data.msgemail;
                vm.username = data.username;
                vm.msgcorrecto = data.msgcorrecto;
                if (vm.msgemail == undefined && vm.msgcorrecto == undefined && vm.msgerror == undefined) {
                     vm.msgerrorlogin=true;
                }
                vm.loading = false;
            });
        };

        vm.login = function(){
        console.log("LOGEANDO");

            vm.errors = false;
            UserService.Login(vm).then(function(data){ 
                vm.errors = data.errors;
                vm.msgcorrecto = data.msgcorrecto;
                vm.msgemail = data.msgemail;

                if (vm.msgemail == undefined && vm.msgcorrecto == undefined && vm.errors == undefined) {
                     vm.msgerrorlogin=true;
                }

                if (data.slugRegistro ) {
                    window.location = data.slugRegistro;
                    window.open(data.slugRegistro,'_system');
                }

            });
        };

        vm.reset = function(form) {
          vm.username ="";
          vm.password ="";
          vm.reseteado = true;
          form.$setPristine();
        }
        
    }
})();